module.exports = __webpack_public_path__ + "media/question2_en.1934e603.mp3";